import { Skeleton } from "antd";
import { RainforestSession } from "../../domain/invoicing/rainforest";
import useRainforestComponents from "./useRainforestComponents";

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "rainforest-chargeback-report": any;
    }
  }
}

type Props = {
  rainforestSession: RainforestSession
}

const ChargebackReport = ({rainforestSession}: Props) => {
  const loadingStatus = useRainforestComponents(rainforestSession)
  if (loadingStatus !== 'READY') {
    return <Skeleton active />
  }

  return <rainforest-chargeback-report
    session-key={rainforestSession.sessionKey}
    data-filters={`{"merchant_id":"${rainforestSession.merchantId}"}`}
    columns={columns}
    show-tabs
    display-records='50'
    show-record-count-selector
    show-export-button
    show-chargeback-respond-button
    style-button-color="#FF5C35"
  ></rainforest-chargeback-report>
}

export default ChargebackReport

const columns = JSON.stringify([
  {"name":"Created","type":"builtin","value":"created"},
  {"name":"Status","type":"builtin","value":"status"},
  {"name":"Amount","type":"builtin","value":"amount"},
  {"name":"Customer","type":"builtin","value":"name"},
  {"name":"Method","type":"builtin","value":"method"},
  {"name":"Due Date","type":"builtin","value":"due_date"},
  {"name":"ARN","type":"builtin","value":"acquirer_ref"},
  {"name": "Customer Link","type": "metadata","value": "$.customer_id","template": "<a style=\"color:blue;text-decoration:underline;\" href=\"/#!/customers#{{value}}\" target=\"_blank\">View Customer</a>"},
  {"name": "Job Link","type": "metadata","value": "$.job_id","template": "<a style=\"color:blue;text-decoration:underline;\" href=\"/#!/job-redirect/{{value}}\" target=\"_blank\">View Job</a>"}
])